<template>
   <el-form ref="pwdRef" class="reset-pwd-form" :model="user" :rules="rules" label-width="180px">
      <el-form-item :label="$t('global.oldPassword')" prop="oldPassword">
         <el-input v-model="user.oldPassword" :placeholder="$t('global.oldPassword') + $t('global.plsInput')" type="password" show-password />
      </el-form-item>
      <el-form-item :label="$t('global.newPassword')" prop="newPassword">
         <el-input v-model="user.newPassword" :placeholder="$t('global.newPassword') + $t('global.plsInput')" type="password" show-password />
      </el-form-item>
      <el-form-item :label="$t('global.confirmPassword')" prop="confirmPassword">
         <el-input v-model="user.confirmPassword" :placeholder="$t('global.plsConfirmNewPassword')" type="password" show-password/>
      </el-form-item>
      <el-form-item class="reset-pwd-form__actions">
         <el-button type="primary" @click="submit">{{ $t('global.save') }}</el-button>
         <el-button type="danger" @click="close">{{ $t('global.close') }}</el-button>
      </el-form-item>
   </el-form>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { updateUserPwd } from "@/api/system/user";

const { proxy } = getCurrentInstance();
const { t } = useI18n();

const user = reactive({
  oldPassword: undefined,
  newPassword: undefined,
  confirmPassword: undefined
});

const equalToPassword = (rule, value, callback) => {
  if (user.newPassword !== value) {
    callback(new Error("两次输入的密码不一致"));
  } else {
    callback();
  }
};
const rules = ref({
  oldPassword: [{ required: true, message: t('global.oldPassword') + t('global.plsInput'), trigger: 'blur' }],
  newPassword: [{ required: true, message: t('global.newPassword') + t('global.plsInput'), trigger: 'blur' }, {
    min: 6, max: 20, message: t('global.limitLength', { min: '6', max: '20' }), trigger: 'blur',
  }],
  confirmPassword: [{ required: true, message: t('global.confirmPassword') + t('global.plsInput'), trigger: 'blur' }, { required: true, validator: equalToPassword, trigger: 'blur' }],
});

/** 提交按钮 */
function submit() {
  proxy.$refs.pwdRef.validate(valid => {
    if (valid) {
      updateUserPwd(user.oldPassword, user.newPassword).then(response => {
        proxy.$modal.msgSuccess(proxy.$t('global.editSuccess'));
      });
    }
  });
};
/** 关闭按钮 */
function close() {
  proxy.$tab.closePage();
};
</script>

<style lang="scss" scoped>
.reset-pwd-form {
  padding-right: 12px;
  box-sizing: border-box;
}
/* 按钮行：右对齐；防止打开 dialog 时被压缩、重叠 */
.reset-pwd-form :deep(.reset-pwd-form__actions .el-form-item__content) {
  min-width: 200px;
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  overflow: visible;
  justify-content: flex-end;
}

@media (max-width: 768px) {
  .reset-pwd-form {
    width: 100%;
  }
  .reset-pwd-form :deep(.el-form-item__label) {
    width: 120px !important;
    min-width: 120px !important;
    padding-right: 8px;
    white-space: nowrap;
    overflow: visible;
  }
  .reset-pwd-form :deep(.el-form-item__content) {
    flex: 1;
    min-width: 0;
    box-sizing: border-box;
  }
  /* 手机端按钮行：整行占满、右对齐，不预留 label 宽度，避免右侧被裁切 */
  .reset-pwd-form :deep(.reset-pwd-form__actions.el-form-item .el-form-item__label) {
    width: 0 !important;
    min-width: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }
  .reset-pwd-form :deep(.reset-pwd-form__actions .el-form-item__content) {
    margin-left: 0 !important;
    width: 100% !important;
    max-width: 100%;
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
    overflow: visible;
    box-sizing: border-box;
    justify-content: flex-end;
  }
  .reset-pwd-form :deep(.reset-pwd-form__actions .el-button) {
    flex: none;
    white-space: nowrap;
  }
  .reset-pwd-form :deep(.el-input) {
    width: 100%;
  }
}
</style>
